// imports section Start
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Divider, Grid } from "@mui/material";
import { formatDate, formatTime } from "../../../utils/common/DateFormat";
import { currencyFormatLKR } from "../../../utils/common/CurrencyFormat";
// imports section End

function PrintKOTBody({
  billOptions,
  mappedOptions,
  orderPayload,
  billType,
  source,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // const formattedDate = formatDate(orderDetails?.[0]?.GROSSAMOUNT);

  // Handlers start

  function formatPrice(value) {
    if (typeof value === "number") {
      return value
        .toFixed(2) // Ensure two decimal places
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add thousand separators
    }
    return value;
  }

  const {
    Table1: orderDetails = [], // Rename Table1 to orderSummary
    Table2: itemCharges = [], // Rename Table2 to itemDetails
    Table3: cartItems = [], // Rename Table3 to totals
  } = orderPayload || {};

  // Filter Service Tax and Service Charge from itemCharges
  const serviceTax =
    itemCharges.find((item) => item.CTTYPE === "Service Tax") || {};
  const serviceCharge =
    itemCharges.find((item) => item.CTTYPE === "Service Charge") || {};

  const priceDetails = [
    {
      label: "Gross Amt.",
      value: formatPrice(orderDetails?.[0]?.GROSSAMOUNT) || "0.00",
    },
    {
      label: "Cash Paid",
      value: formatPrice(orderDetails?.[0]?.CASHAMOUNT) || "0.00",
    },
    {
      label: "Card Paid",
      value: formatPrice(orderDetails?.[0]?.CARDAMOUNT) || "0.00",
    },
    {
      label: "Tax Amount",
      value: formatPrice(serviceTax?.CTAMOUNT) || "0.00",
    },
    {
      label: "Charge Amount",
      value: formatPrice(serviceCharge?.CTAMOUNT) || "0.00",
    },

    {
      label: "Bill Amt.",
      value: formatPrice(orderDetails?.[0]?.BILLAMOUNT) || "0.00",
    },
    {
      label: "Advance Amt.",
      value: formatPrice(orderDetails?.[0]?.ADVANCEAMOUNT) || "0.00",
    },
    {
      label: "Total Paid Amt.",
      value: formatPrice(orderDetails?.[0]?.PAIDAMOUNT) || "0.00",
    },

    {
      label: "Balance Amt.",
      value: formatPrice(orderDetails?.[0]?.BALANCEAMOUNT) || "0.00",
    },
    // {
    //   label: "Credit Amt.",
    //   value: formatPrice(orderDetails?.[0]?.CREDITDUEAMOUNT) || "0.00",
    //   // highlight: false,
    // },
  ];
  // BillOption 15,6

  // Only add "Credit Amt." if this is a PlaceOrder bill
  if (source === "CashierSummery") {
    priceDetails.push({
      label: "Credit Amt.",
      value: formatPrice(orderDetails?.[0]?.CREDITDUEAMOUNT),
    });
  }

  const tableName = orderDetails?.[0]?.TABLENAME;
  // Handlers end

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 1,
          }}
        >
          <Grid container>
            {/* Invoice Header */}
            {mappedOptions.has(6) && (
              <Grid item xs={12} mb={1} textAlign="center">
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color={theme.palette.text.tertiary}
                >
                  Order No : {orderDetails?.[0]?.ORDERCODE}
                </Typography>
                <Divider
                  sx={{
                    marginY: 1,
                    borderBottomWidth: 2,
                    borderStyle: "dotted",
                  }}
                />
              </Grid>
            )}

            {/* Order Information */}
            {[
              {
                label: "Order Type",
                value: orderDetails?.[0]?.ORDERTYPE,
                key: 8,
              },

              { label: "KOT No.", value: orderDetails?.[0]?.KOTCODE, key: 10 },
              {
                label: "Order Date",
                value: formatDate(orderDetails?.[0]?.PAYDATE),
                key: 11,
              },
              //   {
              //     label: "Invoice Date",
              //     value: formatDate(orderDetails?.[0]?.ORDERENDATE),
              //     key: 12,
              //   },

              {
                label: "Table",
                value:
                  typeof orderDetails?.[0]?.TABLENAME === "string"
                    ? orderDetails[0].TABLENAME
                    : orderDetails?.[0]?.TABLENAME?.name || "N/A",
                key: 14,
              },
            ]
              .filter((item) => mappedOptions.has(item.key)) // Filter active options
              .reduce((rows, item, index, array) => {
                if (index % 2 === 0) rows.push(array.slice(index, index + 2)); // Group into rows
                return rows;
              }, [])
              .map((row, rowIndex) => (
                <Grid container key={rowIndex} mb={1}>
                  {row.map((col, colIndex) => (
                    <Grid
                      item
                      xs={6}
                      key={colIndex}
                      sx={colIndex % 2 === 1 ? styles.cr_right_align : {}}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        {col.label}
                      </Typography>
                      <Typography variant="body2">{col.value}</Typography>
                    </Grid>
                  ))}
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
      <Box>
        {/* Items List */}
        {/* Items List */}
        <Divider
          sx={{
            marginY: 1,
            borderBottomWidth: 2,
            borderStyle: "dotted",
          }}
        />
        <Box>
          {cartItems.map((item, index) => (
            <Grid container key={index} sx={{ marginBottom: 1 }}>
              {/* Left side: Item Name and Quantity */}
              <Grid item xs={8} display={"flex"} flexDirection={"column"}>
                <Typography variant="body1">{item.MENUNAME}</Typography>
                <Typography variant="body2"></Typography>
              </Grid>

              {/* Right side: Total Price */}
              <Grid
                item
                xs={4}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"flex-end"}
              >
                <Typography variant="body2" fontWeight="bold">
                  * {item.QTY}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>

        {/* <Divider
          sx={{
            marginY: 1,
            borderBottomWidth: 2,
            borderStyle: "dotted",
          }}
        /> */}

        <Divider sx={{ marginY: 1 }} />
      </Box>
    </>
  );
}

export default PrintKOTBody;
